import { createToastInterface, POSITION } from "vue-toastification";
import "vue-toastification/dist/index.css";

const toast = createToastInterface({
  position: POSITION.TOP_RIGHT,
  timeout: 4000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  hideProgressBar: false,
});

export default toast;
